import React from 'react';

import { SkeletonBlock } from '../../../../components/skeleton/skeleton';

export default function OrderDetailSkeleton() {
  return (
    <div className="order-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-5xl space-y-8">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <SkeletonBlock className="h-0.5 w-6 rounded-full" />
            <SkeletonBlock className="h-3 w-28 rounded" />
          </div>
          <SkeletonBlock className="h-8 w-52 max-w-[85%] rounded-md sm:h-9" />
          <SkeletonBlock className="h-4 w-full max-w-2xl rounded" />
        </div>

        <div className="ml-auto flex w-fit max-w-full justify-end gap-3 rounded-md border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800">
          <SkeletonBlock className="h-9 w-9 shrink-0 rounded-full" />
          <SkeletonBlock className="h-10 w-36 rounded-full" />
        </div>

        <section className="flex flex-col gap-4 rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <SkeletonBlock className="h-16 w-16 shrink-0 rounded-md" />
            <div className="min-w-0 space-y-2">
              <SkeletonBlock className="h-3 w-16 rounded" />
              <SkeletonBlock className="h-7 w-48 max-w-[70vw] rounded-md" />
              <SkeletonBlock className="h-3 w-full max-w-md rounded" />
              <SkeletonBlock className="h-3 w-32 rounded" />
            </div>
          </div>
          <SkeletonBlock className="h-10 w-28 self-start rounded-full sm:self-center" />
        </section>

        <div className="rounded-md border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800">
          <SkeletonBlock className="h-4 w-40 rounded" />
          <SkeletonBlock className="mt-3 h-5 w-56 max-w-full rounded" />
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="overflow-hidden rounded-md border border-slate-200 shadow-sm dark:border-slate-700"
            >
              <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3 dark:border-slate-700/60">
                <SkeletonBlock className="h-7 w-7 rounded-md" />
                <SkeletonBlock className="h-3 w-36 rounded" />
              </div>
              <div className="space-y-3 px-5 py-5">
                <SkeletonBlock className="h-8 w-32 rounded-md" />
                <SkeletonBlock className="h-4 w-full max-w-xs rounded" />
                <SkeletonBlock className="h-4 w-24 rounded" />
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-md border border-slate-200 bg-white dark:border-slate-700">
          <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3 dark:border-slate-700/60">
            <SkeletonBlock className="h-7 w-7 rounded-md" />
            <SkeletonBlock className="h-3 w-24 rounded" />
          </div>
          {[0, 1, 2].map((row) => (
            <div
              key={row}
              className="flex items-center gap-4 border-b border-slate-100 px-5 py-4 last:border-0 dark:border-slate-700/60"
            >
              <SkeletonBlock className="h-12 w-12 shrink-0 rounded-md" />
              <div className="min-w-0 flex-1 space-y-2">
                <SkeletonBlock className="h-4 w-48 max-w-[70%] rounded" />
                <SkeletonBlock className="h-3 w-24 rounded" />
              </div>
              <SkeletonBlock className="h-4 w-16 shrink-0 rounded" />
            </div>
          ))}
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800">
          <div className="flex justify-between gap-4 border-b border-slate-100 pb-4 dark:border-slate-700/60">
            <SkeletonBlock className="h-4 w-24 rounded" />
            <SkeletonBlock className="h-4 w-20 rounded" />
          </div>
          <div className="mt-4 space-y-2">
            {[0, 1, 2, 3].map((r) => (
              <div key={r} className="flex justify-between gap-4">
                <SkeletonBlock className="h-3 w-28 rounded" />
                <SkeletonBlock className="h-3 w-16 rounded" />
              </div>
            ))}
            <SkeletonBlock className="mt-4 h-px w-full rounded-full" />
            <div className="flex justify-between pt-2">
              <SkeletonBlock className="h-5 w-20 rounded" />
              <SkeletonBlock className="h-6 w-24 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
